import Card from "../components/ui/Card";
import TopicPill from "../components/ui/TopicPill";
import { topicCategories, totalTopics } from "../data/skills";

const Topics = () => {
  return (
    <div className="page topics-page">
      <div className="page-head">
        <h1 className="page-title">
          Topics <span className="page-title-alt">/ Skills</span>
        </h1>
        <span className="page-sub">
          {totalTopics} technologies & tools across {topicCategories.length}{" "}
          categories
        </span>
      </div>

      <div className="topics-grid">
        {topicCategories.map((cat) => (
          <Card
            key={cat.name}
            title={cat.name}
            action={<span className="count-pill">{cat.items.length}</span>}
            className="topic-cat-card"
          >
            <div className="topic-cat-pills">
              {cat.items.map((name) => (
                <TopicPill key={name} name={name} colorIcon />
              ))}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default Topics;
